export const MenuItems = [
  {
    title: 'Navigation',
    url: 'null',
    cName: 'nav-links menu',
    target: false
  }, {
    title: 'Home',
    url: 'home',
    cName: 'nav-links',
    target: false
  },
  {
    title: 'Projects',
    url: 'projects',
    cName: 'nav-links',
    target: false
  },
  {
    title: 'Skills',
    url: 'skills',
    cName: 'nav-links',
    target: false
  },
  {
    title: 'About Me',
    url: 'aboutMe',
    cName: 'nav-links',
    target: true
  },
  {
    title: 'Contact',
    url: 'contact',
    cName: 'nav-links',
    target: false
  }
]